import React, { Fragment } from 'react';

import AthleteUserEntriesSelectionLargeGrid from './AthleteUserEntriesSelectionLargeGrid';
import AthleteUserEntriesSelectionSmallGrid from './AthleteUserEntriesSelectionSmallGrid';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const AthleteUserEntriesSelectionGrid = ({ gridData, isLoading, onCheckboxChange, bonus, onAddOverrideEntryClicked, onEditOverrideEntryClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            {gridData.length > 499
              ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p> :
              <p>{gridData.length === 1 ? `${gridData.length} Search Result` : `${gridData.length} Search Results`}</p>}
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <AthleteUserEntriesSelectionLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        bonus={bonus}
        onAddOverrideEntryClicked={onAddOverrideEntryClicked}
        onEditOverrideEntryClicked={onEditOverrideEntryClicked}
      />
      <AthleteUserEntriesSelectionSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        bonus={bonus}
        onAddOverrideEntryClicked={onAddOverrideEntryClicked}
        onEditOverrideEntryClicked={onEditOverrideEntryClicked}
      />
    </Fragment>
  )
};

export default AthleteUserEntriesSelectionGrid;